import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Button, Dropdown, Menu, message, DatePicker } from 'antd';
import Icon from 'antd/es/icon';
import { request } from '../../util/APIUtils';
import { API_BASE_URL } from '../../constants';
import LoadingIndicator from '../../common/LoadingIndicator';
import Table from '../../components/Table/Table';
import DetailedSearch from '../../components/DetailedSearch/DetailedSearch';
import DutyRosterForm from './DutyRosterForm';
import DutyRosterDeleteModal from './DutyRosterDeleteModal';
import { showAxiosError } from '../../util/Helpers';
import './dutyRoster.css';
import Alert from "react-s-alert";

class DutyRoster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rosters: [],
            error: null,
            loading: false,
            selectedRoster: null,
            selectedItem: null,
            isEditModalOpen: false,
            addDeleteModal: false,
            add: false,
            total: 0,
            size: 10,
            page: 0,
            regions: [],
            selectedRegion: null,
            filterDate: null,
            searchQuery: '',
            publishing: false
        };

        this.fetchRosters = this.fetchRosters.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.loadRegions = this.loadRegions.bind(this);
        this.handleRegionChange = this.handleRegionChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.setIsYayinTrueIsUpdateFalse = this.setIsYayinTrueIsUpdateFalse.bind(this);
    }

    componentDidMount() {
        this.loadRegions();
        this.fetchRosters();
    }

    loadRegions = () => {
        request({
            url: API_BASE_URL + "/regions",
            method: "get"
        })
            .then(response => {
                const list = response.data.content || response.data || [];
                const regionOptions = list.map(r => ({
                    value: r.id,
                    label: r.regionName
                }));
                this.setState({ regions: regionOptions });
            })
            .catch(() => message.error('Bölgeler yüklenemedi.'));
    };

    fetchRosters() {
        let url = `${API_BASE_URL}/duty-rosters/list-grouped`;
        if (this.state.searchQuery) {
            url += `?${this.state.searchQuery}`;
        }

        this.setState({ loading: true });

        request({ url, method: 'GET' })
            .then(response => {
                const data = Array.isArray(response.data)
                    ? response.data
                    : Array.isArray(response)
                        ? response
                        : [];

                this.setState({
                    rosters: data,
                    total: data.length,
                    loading: false,
                });
            })
            .catch(err => {
                this.setState({ loading: false });
                showAxiosError(err);
            });
    }

    handleGeneratePdf = (item) => {
        if (!item || !item.rosterId) {
            message.error("PDF oluşturmak için geçersiz kayıt.");
            return;
        }

        request({
            url: API_BASE_URL + "/duty-rosters/" + item.rosterId + "/generate-pdf",
            method: "POST"
        })
            .then(() => {
                message.success("PDF oluşturuldu.");
                this.fetchRosters();
            })
            .catch(err => {
                showAxiosError(err);
                message.error("PDF oluşturulamadı.");
            });
    };

    handleDownloadCsv = async () => {
        try {
            message.loading("Tüm nöbet listeleri oluşturuluyor, lütfen bekleyin...", 2);

            const response = await request({
                url: `${API_BASE_URL}/duty-rosters/export-all-csv`,
                method: 'GET'
            });

            const files = response.data || [];
            if (!files.length) {
                message.warning("Herhangi bir nöbet listesi bulunamadı.");
                return;
            }

            message.success(`${files.length} adet CSV dosyası oluşturuldu `);
        } catch (error) {
            console.error(error);
            message.error("CSV dosyaları oluşturulurken hata oluştu!");
        }
    };

    handlePublishAll = async () => {
        this.setState({ publishing: true });

        const hide = message.loading(
            "Tüm yayınlanmamış nöbet listeleri yayınlanıyor, lütfen bekleyin...",
            0
        );

        try {
            await request({
                url: API_BASE_URL + "/duty-rosters/publish-all",
                method: "POST"
            });
            hide();
            message.success("Tüm nöbet listeleri yayınlandı.");
            this.fetchRosters();
            this.setState({ publishing: false });
        } catch (error) {
            hide();
            this.setState({ publishing: false });
            message.error("Toplu yayınlama sırasında hata oluştu.");
        }
    };


    handleSearch(searchQuery) {
        console.log('DetailedSearch output:', searchQuery);

        let params = '';

        if (typeof searchQuery === 'string') {
            params = searchQuery;
        } else if (typeof searchQuery === 'object') {
            const sp = new URLSearchParams();
            if (searchQuery['region.regionName.equals'])
                sp.append('region.regionName.equals', searchQuery['region.regionName.equals']);
            if (searchQuery['dutyDate.equals'])
                sp.append('dutyDate.equals', searchQuery['dutyDate.equals']);
            if (searchQuery['createdDate.equals'])
                sp.append('createdDate.equals', searchQuery['createdDate.equals']);
            params = sp.toString();
        }

        console.log('Generated query params:', params);

        this.setState({ searchQuery: params }, () => this.fetchRosters());
    }


    handleEdit = item => {
        this.setState({
            selectedRoster: item,
            isEditModalOpen: true,
            add: false,
        });
    };

    handleDelete = item => {
        this.setState({
            selectedRoster: item,
            addDeleteModal: true,
        });
    };

    setIsYayinTrueIsUpdateFalse = (targetId) => {
        const updatedRosters = this.state.rosters.map((item) =>
            item.id === targetId ? { ...item, isyayin: true, isupdate: false } : item
        );
        this.setState({ rosters: updatedRosters });
    };

    handleYayin(item) {
        console.log("item:: ", item);
        let self = this;
        const hide = message.loading(
            "Nöbet listesi yayınlanıyor, lütfen bekleyin...",
            0
        );

        let params = {
            url: API_BASE_URL + "/duty-rosters/wordpressgonder",
            data: JSON.stringify(item.id),
            method: 'post'
        };
        request(params).then(function (response) {
            hide();
            const message = "Eczane Nöbet Listesi yayınlandı."
            Alert.success(
                message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
        }).catch(function (error) {
            showAxiosError(error);
        }).finally(() => {
            this.setIsYayinTrueIsUpdateFalse(item.id);
            console.log('finished:: ', item);
        });
    }

    addNew = () => {
        this.setState({
            selectedRoster: null,
            isEditModalOpen: true,
            add: true,
        });
    };

    cancelProcess = () => {
        this.setState({
            isEditModalOpen: false,
            addDeleteModal: false,
            add: false,
        });
        this.fetchRosters();
    };

    handleMenuClick = e => {
        if (e.key === '1') {
            this.handleEdit(this.state.selectedItem);
        } else if (e.key === '2') {
            this.handleDelete(this.state.selectedItem);
        } else if (e.key === '3') {
            this.handleYayin(this.state.selectedItem);
        }
    };


    handleRegionChange(selectedRegion) {
        this.setState({ selectedRegion });
    }

    handleDateChange(date) {
        this.setState({ filterDate: date });
    }

    renderPublishStatus = (item) => {
        if (item.isyayin && item.isupdate) {
            return <span style={{ color: "#fa8c16", fontWeight: 600 }}>
                Yayınlandı & Güncelleme Var
            </span>;
        }

        if (item.isyayin) {
            return <span style={{ color: "green", fontWeight: 600 }}>
                Yayınlandı
            </span>;
        }

        // if (item.isupdate) {
        //     return <span style={{ color: "#faad14", fontWeight: 600 }}>
        //     Güncelleme Var
        // </span>;
        // }

        return <span style={{ color: "gray" }}>
            Yayınlanmadı
        </span>;
    };

    render() {
        const menu = (
            <Menu onClick={this.handleMenuClick}>
                {this.state.selectedItem && <Menu.Item key="1">Listeyi Düzenle</Menu.Item>}
                {this.state.selectedItem && <Menu.Item key="2">Listeyi Sil</Menu.Item>}
                {this.state.selectedItem && <Menu.Item key="3" disabled={this.state.publishing}>Listeyi Yayınla</Menu.Item>}
            </Menu>
        );

        const columns = [
            {
                Header: 'Nöbet Tarihi',
                accessor: 'dutyDate',
                Cell: item => {
                    if (item.dutyDate) {
                        return item.dutyDate.split('T')[0];
                    }
                    return '';
                }
            },
            { Header: 'Bölge', accessor: 'regionName' },
            {
                Header: 'Nöbetçi Sayısı',
                accessor: 'dutyCount',
                getTdStyles: () => ({ textAlign: "center" }),
                Cell: item => <label>{item.dutyCount || 0}</label>,
            },
            // {
            //     Header: 'PDF',
            //     accessor: 'pdfPath',
            //     sortable: false,
            //     getTdStyles: () => ({textAlign: "center"}),
            //     Cell: item => (
            //         <div>
            //             {item.pdfPath ? (
            //                 <a
            //                     href={API_BASE_URL + "/duty-rosters/" + item.rosterId + "/pdf"}
            //                     target="_blank"
            //                     rel="noopener noreferrer"
            //                 >
            //                     PDF İndir
            //                 </a>
            //             ) : (
            //             <Button
            //                 size="small"
            //                 onClick={() => this.handleGeneratePdf(item)}
            //                 style={{
            //                     background: '#4CAF50',
            //                     borderColor: '#4CAF50',
            //                     color: 'white',
            //                     fontSize: '12px',
            //                 }}
            //             >
            //                 Eczane Kartı Yayınla
            //             </Button>
            //             )}
            //         </div>
            //     ),
            // },
            {
                Header: 'İşlemler',
                accessor: '',
                sortable: false,
                getTdStyles: () => ({ textAlign: "center" }),
                Cell: item => (
                    <div>
                        <Dropdown
                            overlay={menu}
                            trigger={['click']}
                            onClick={() => this.setState({ selectedItem: item })}
                        >
                            <Button
                                style={{
                                    background: '#3b6b96',
                                    height: '30px',
                                    width: '100px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                    fontSize: '12px',
                                }}
                            >
                                Seçiniz <Icon type="down" />
                            </Button>
                        </Dropdown>
                    </div>
                ),
            },
            {
                Header: "Durum",
                accessor: "",
                getTdStyles: () => ({ textAlign: "center" }),
                Cell: item => this.renderPublishStatus(item)
            },
        ];

        const start = this.state.page * this.state.size;
        const end = start + this.state.size;
        const pagedRosters = this.state.rosters.slice(start, end);
        console.log("paged rosters:: ", pagedRosters);
        return (
            <div className="row baseBackground">
                {/*{this.state.loading && (*/}
                {/*    <div className="loader">*/}
                {/*        <LoadingIndicator/>*/}
                {/*    </div>*/}
                {/*)}*/}

                <div className="col-md-12 satirBasi">
                    <div className="card-header">
                        <h4 className="card-title">Nöbet Listeleri</h4>
                    </div>

                    <div className="card-body mt-1">
                        <DetailedSearch
                            fields={[
                                { label: 'Bölge', accessor: 'region.regionName', type: 'text', operator: '.equals=' },
                                { label: 'Tarih', accessor: 'dutyDate', type: 'date', operator: '.equals=' },
                            ]}
                            loading={this.state.loading}
                            onSearch={this.handleSearch}
                        />
                    </div>

                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            content={pagedRosters}
                            total={this.state.rosters.length}
                            page={this.state.page}
                            size={this.state.size}
                            columns={columns}
                            style={{ width: "100%" }}
                            options={['5', '10', '20', '50', '100']}
                            fetchData={(sort, filter, page, size) => {
                                if (page === undefined || size === undefined) return;
                                this.setState({ page, size });
                            }}
                        />

                    </div>


                    <div className="new-button-holder">
                        <button
                            type="button"
                            title="Yeni Nöbet Listesi"
                            disabled={this.state.loading}
                            className="TekBtn add-new-member"
                            style={{
                                background: 'linear-gradient(#2b93cd, #0a66b7)',
                                height: '40px',
                                width: '180px',
                                float: 'right',
                                marginRight: '30px',
                                color: 'white',
                                borderRadius: '0.375em',
                            }}
                            onClick={this.addNew}
                        >
                            YENİ NÖBET LİSTESİ
                        </button>
                        <button
                            type="button"
                            disabled={this.state.publishing}
                            className="TekBtn add-new-member"
                            style={{
                                background: this.state.publishing
                                    ? "#999"
                                    : "linear-gradient(#28a745, #218838)",
                                height: "40px",
                                width: "260px",
                                float: "right",
                                marginRight: "10px",
                                color: "white",
                                borderRadius: "0.375em",
                                cursor: this.state.publishing ? "not-allowed" : "pointer"
                            }}
                            onClick={this.handlePublishAll}
                        >
                            {this.state.publishing
                                ? "Yayınlanıyor..."
                                : "TÜM NÖBET LİSTELERİNİ YAYINLA"}
                        </button>

                    </div>
                </div>

                <Modal isOpen={this.state.isEditModalOpen} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelProcess}>
                        {this.state.add ? 'Yeni Nöbet Listesi Oluştur' : 'Nöbet Listesi Düzenle'}
                    </ModalHeader>
                    <ModalBody style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
                        <DutyRosterForm
                            selectedDate={this.state.selectedRoster ? this.state.selectedRoster.dutyDate : null}
                            selectedRoster={this.state.selectedRoster}
                            addMode={this.state.add}
                            cancelProcess={this.cancelProcess}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelProcess}>Nöbet Listesi Silme</ModalHeader>
                    <ModalBody style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
                        <DutyRosterDeleteModal
                            cancelProcess={this.cancelProcess}
                            selectedRoster={this.state.selectedRoster}
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default DutyRoster;



// WEBPACK FOOTER //
// ./src/page/dutyRoster/dutyRoster.js